"use client";

import { Suspense, useEffect } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { useAuth } from "@/contexts/AuthContext";
import { AbilitiesTabPageSkeleton } from "@/components/abilities/MarketplaceGrid";
import { MarketplaceTabsBar } from "@/components/marketplace/MarketplaceTabsBar";
import { AbilitiesBody } from "@/components/abilities/AbilitiesBody";

export default function AbilitiesPage() {
  const { loading } = useAuth();
  // Public: anon visitors browse the abilities marketplace (install is gated
  // behind sign-in inside the grid). No /login redirect.
  if (loading) return <AbilitiesTabPageSkeleton />;
  return (
    <Suspense fallback={<AbilitiesTabPageSkeleton />}>
      <AbilitiesRoute />
    </Suspense>
  );
}

// Legacy deep links (/abilities?tab=skills|agents) -> canonical routes.
function AbilitiesRoute() {
  const router = useRouter();
  const { user } = useAuth();
  const tab = useSearchParams()?.get("tab");
  useEffect(() => {
    if (tab === "skills") router.replace("/skills");
    else if (tab === "agents") router.replace("/agents");
  }, [tab, router]);
  if (tab === "skills" || tab === "agents") return null;
  // Logged-in users are in the app-sidebar shell (no top bar), so render the
  // in-page Abilities/Skills/Agents switcher. Anon visitors get those tabs
  // from MarketplaceShell's top bar instead.
  return (
    <>
      {user && (
        <div className="px-4 md:px-8 pt-6 pb-1">
          <MarketplaceTabsBar />
        </div>
      )}
      <AbilitiesBody />
    </>
  );
}
